import React from 'react';

import Spinner from 'components/WrappedComponents/Spinner';
import { useProprietaireInfos } from 'hooks/sortieVehicule/useProprietaireInfos';
import { FieldSummaryDisplay } from 'pages/gardien-fourriere/FicheDescriptive/SummaryConfirm/FieldSummaryDisplay';

import {
  VERIFICATION_PRE_SORTIE_CHECKBOX_TEXT,
  VERIFICATION_PRE_SORTIE_TEXT,
} from './constants';

import './VerificationPreSortieInfoProprietaire.less';

interface VerificationPreSortieProps {
  dossierId: string;
  children?: React.ReactNode;
}

const VerificationPreSortieInfoProprietaire = ({
  dossierId,
  children,
}: VerificationPreSortieProps): React.ReactElement => {
  const { proprietaireInfos, loading } = useProprietaireInfos(dossierId);

  const isLoading = loading || !proprietaireInfos;

  return (
    <>
      <p>{VERIFICATION_PRE_SORTIE_TEXT}</p>
      <div className="infos-container">
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            {proprietaireInfos?.nom && (
              <FieldSummaryDisplay label="nom">
                <p>
                  <b>{proprietaireInfos?.nom}</b>
                </p>
              </FieldSummaryDisplay>
            )}
            {proprietaireInfos?.prenom && (
              <FieldSummaryDisplay label="prénom">
                <p>
                  <b>{proprietaireInfos?.prenom}</b>
                </p>
              </FieldSummaryDisplay>
            )}
            {proprietaireInfos?.raisonSociale && (
              <FieldSummaryDisplay label="Raison sociale">
                <p>
                  <b>{proprietaireInfos?.raisonSociale}</b>
                </p>
              </FieldSummaryDisplay>
            )}
          </>
        )}
      </div>
      <div className="verification-pre-sortie-checkbox">{children}</div>
      <p>{VERIFICATION_PRE_SORTIE_CHECKBOX_TEXT}</p>
    </>
  );
};

export default VerificationPreSortieInfoProprietaire;
